import { Link } from "react-router-dom";

// In-app 404. Under static hosting, CloudFront maps 403/404 to index.html so
// any unknown deep link still boots the SPA; this catch-all route is what the
// router then renders, instead of a broken hosting-level error page.
export function NotFoundPage() {
  return (
    <section className="flex flex-col items-center gap-4 py-16 text-center">
      <p className="text-5xl font-bold text-brk-accent">404</p>
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="max-w-prose text-white/70">
        The page you’re looking for doesn’t exist or has moved.
      </p>
      <Link
        to="/"
        className="rounded-md border border-white/20 px-4 py-2 font-medium text-white transition-colors hover:bg-white/10"
      >
        Back to home
      </Link>
    </section>
  );
}
